/* eslint-disable import/named */
import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from '../constants';
import * as services from './service';
import * as Notification from './notification-saga';

// helpers
import { getCookie } from '../helpers';

export function* getSettingAppSaga(actions) {
  const response = yield call(services.getSettingAppService, { ...actions });
  if (response) {
    yield put({
      type: types.GET_SETTING_APP_RESULT,
      res: response
    });
  }
}

export function* getTopProductsViewedSaga(actions) {
  const response = yield call(services.getTopProductsViewedService, { ...actions });
  if (response) {
    yield put({
      type: types.GET_TOP_PRODUCTS_VIEWED_RESULT,
      res: response
    });
  } else {
    yield put({
      type: types.GET_TOP_PRODUCTS_VIEWED_RESULT
    });
  }
}

function* getStatisticChartSaga(actions) {
  const result = yield call(services.getStatisticChartService, actions.payload);

  yield put({
    type: types.GET_STATISTIC_CHART_RESULT,
    res: result
  });
}

export function* getReportAppSaga(actions) {
  const response = yield call(services.getReportAppService, { ...actions });
  if (response) {
    yield put({
      type: types.GET_REPORT_APP_RESULT,
      res: response
    });
  } else {
    yield put({
      type: types.GET_REPORT_APP_RESULT,
      res: response
    });
  }
}

export function* getSettingProductHistorySaga(actions) {
  const response = yield call(services.getSettingProductHistoryService, { ...actions });

  if (response && response.shop_id) {
    yield put({
      type: types.GET_SETTING_PRODUCTS_HISTORY_RESULT,
      res: response
    });
  } else {
    yield put({
      type: types.GET_SETTING_PRODUCTS_HISTORY_RESULT
    });
  }
}

export function* saveSettingProductHistorySaga() {
  const url = getCookie();

  const response = yield call(services.saveSettingProductHistoryService, {
    url
  });
  if (response && response.success) {
    yield put({
      type: types.SAVE_SETTING_PRODUCTS_HISTORY_RESULT,
      res: 1
    });
  } else {
    yield put({
      type: types.SAVE_SETTING_PRODUCTS_HISTORY_RESULT,
      res: 2
    });
  }
}

export function* getSettingTrendingProductSaga(actions) {
  const response = yield call(services.getSettingTrendingProductService, { ...actions });

  if (response && response.shop_id) {
    yield put({
      type: types.GET_SETTING_TRENDING_PRODUCT_RESULT,
      res: response
    });
  } else {
    yield put({
      type: types.GET_SETTING_TRENDING_PRODUCT_RESULT
    });
  }
}

export function* saveSettingTrendingProductSaga() {
  const url = getCookie();

  const response = yield call(services.saveSettingTrendingProductService, {
    url
  });
  if (response && response.success) {
    yield put({
      type: types.SAVE_SETTING_TRENDING_PRODUCT_RESULT,
      res: 1
    });
  } else {
    yield put({
      type: types.SAVE_SETTING_TRENDING_PRODUCT_RESULT,
      res: 2
    });
  }
}

export function* getSettingTopDiscountSaga(actions) {
  const response = yield call(services.getSettingTopDiscountService, { ...actions });

  if (response && response.shop_id) {
    yield put({
      type: types.GET_SETTING_TOP_DISCOUNT_RESULT,
      res: response
    });
  } else {
    yield put({
      type: types.GET_SETTING_TOP_DISCOUNT_RESULT
    });
  }
}

export function* saveSettingTopDiscountSaga() {
  const url = getCookie();

  const response = yield call(services.saveSettingTopDiscountService, {
    url
  });
  if (response && response.success) {
    yield put({
      type: types.SAVE_SETTING_TOP_DISCOUNT_RESULT,
      res: 1
    });
  } else {
    yield put({
      type: types.SAVE_SETTING_TOP_DISCOUNT_RESULT,
      res: 2
    });
  }
}

export function* getListProductsDetailSaga(payload) {
  const url = getCookie();

  const response = yield call(services.getListProductsDetailService, { url, ...payload });
  if (response && response.products) {
    yield put({
      type: types.GET_LIST_PRODUCTS_DETAIL_RESULT,
      products: response.products
    });
  } else {
    yield put({
      type: types.GET_LIST_PRODUCTS_DETAIL_RESULT
    });
  }
}

export function* getSettingBestSellingSaga(actions) {
  const response = yield call(services.getSettingBestSellingService, { ...actions });

  if (response && response.shop_id) {
    yield put({
      type: types.GET_SETTING_BEST_SELLING_RESULT,
      res: response
    });
  } else {
    yield put({
      type: types.GET_SETTING_BEST_SELLING_RESULT
    });
  }
}

export function* saveSettingBestSellingSaga() {
  const url = getCookie();

  const response = yield call(services.saveSettingBestSellingService, {
    url
  });
  if (response && response.success) {
    yield put({
      type: types.SAVE_SETTING_BEST_SELLING_RESULT,
      res: 1
    });
  } else {
    yield put({
      type: types.SAVE_SETTING_BEST_SELLING_RESULT,
      res: 2
    });
  }
}

export function* getListProductsDetailBestSellingSaga(payload) {
  const url = getCookie();

  const response = yield call(services.getListProductsDetailService, { url, ...payload });
  if (response && response.products) {
    yield put({
      type: types.GET_LIST_PRODUCTS_DETAIL_BEST_SELLING_RESULT,
      products: response.products
    });
  } else {
    yield put({
      type: types.GET_LIST_PRODUCTS_DETAIL_BEST_SELLING_RESULT
    });
  }
}

export function* getSettingQuickViewSaga(actions) {
  const response = yield call(services.getSettingQuickViewService, { ...actions });
  if (response && response.shop_id) {
    yield put({
      type: types.GET_SETTING_QUICK_VIEW_RESULT,
      res: response
    });
  } else {
    yield put({
      type: types.GET_SETTING_QUICK_VIEW_RESULT
    });
  }
}

export function* saveSettingQuickViewSaga() {
  const url = getCookie();

  const response = yield call(services.saveSettingQuickViewService, {
    url
  });
  if (response && response.success) {
    yield put({
      type: types.SAVE_SETTING_QUICK_VIEW_RESULT,
      res: 1
    });
  } else {
    yield put({
      type: types.SAVE_SETTING_QUICK_VIEW_RESULT,
      res: 2
    });
  }
}

export function* getListNotificationSaga(data) {
  const response = yield call(Notification.getListNotificationService, data.shop);
  if (response) {
    yield put({
      type: types.GET_LIST_NOTIFICATION_RESULT,
      payload: response
    });
  } else {
    console.log(response);
  }
}

export function* getNotificationDetailSaga(data) {
  const response = yield call(Notification.getNotificationDetailService, data.shop, data.id);
  if (response) {
    yield put({
      type: types.GET_NOTIFICATION_DETAIL_RESULT,
      payload: response
    });
  } else {
    console.log(response);
  }
}

export function* updateNotificationSaga(data) {
  const response = yield call(Notification.updateNotificationService, data.shop, data.id);
  if (response) {
    yield put({
      type: types.GET_LIST_NOTIFICATION,
      shop: data.shop
    });
  } else {
    console.log(response);
  }
}

export function* getPlanPackageSaga() {
  const response = yield call(services.getPlanPackageSagaServer);
  if (response) {
    yield put({
      type: types.GET_PLAN_PACKAGE_REUSLT,
      res: response
    });
  }
}

export function* upgradePlanPackageSaga(actions) {
  const response = yield call(services.upgradePlanPackageSagaServer, actions.plan);
  if (response && response.confirmation_url) {
    window.location.href = response.confirmation_url;
  } else {
    window.location.href = '/pricing';
  }
}

export function* getDataShopInfo(actions) {
  const url = getCookie();
  const response = yield call(services.getDataShopInfoServer, {
    url,
    ...actions
  });
  if (
    response &&
    response.myshopify_domain &&
    response.myshopify_domain.includes('.myshopify.com')
  ) {
    yield put({
      type: types.SET_DATA_SHOP_RESULT,
      payload: response
    });
    window.fcWidget.user.setProperties({
      firstName: response.name,
      shopOwner: response.shop_owner,
      email: response.email,
      phone: response.phone,
      timezone: response.timezone,
      planName: response.plan_name,
      shop: response.myshopify_domain
    });
    const style = document.createElement('style');
    style.innerHTML = '#fc_frame{display: unset!important;}';
    document.body.appendChild(style);
  }
}

export function* changeAppStatusSaga(actions) {
  const url = getCookie();
  const response = yield call(services.changeAppStatusService, {
    url,
    ...actions
  });

  if (response) {
    yield put({
      type: types.CHANGE_APP_STATUS_RESULT,
      payload: response
    });
  } else {
    yield put({
      type: types.CHANGE_APP_STATUS_RESULT
    });
  }
}

function* sagaActions() {
  yield takeEvery(types.GET_SETTING_APP, getSettingAppSaga);
  yield takeEvery(types.CHANGE_APP_STATUS, changeAppStatusSaga);
  yield takeEvery(types.GET_STATISTIC_CHART, getStatisticChartSaga);
  yield takeEvery(types.GET_LIST_NOTIFICATION, getListNotificationSaga);
  yield takeEvery(types.UPDATE_NOTIFICATION, updateNotificationSaga);

  yield takeEvery(types.GET_PLAN_PACKAGE, getPlanPackageSaga);
  yield takeEvery(types.UPGRADE_PLAN_PACKAGE, upgradePlanPackageSaga);
  yield takeEvery(types.GET_DATA_SHOP, getDataShopInfo);
  yield takeEvery(types.GET_TOP_PRODUCTS_VIEWED, getTopProductsViewedSaga);

  yield takeEvery(types.GET_SETTING_PRODUCTS_HISTORY, getSettingProductHistorySaga);
  yield takeEvery(types.SAVE_SETTING_PRODUCTS_HISTORY, saveSettingProductHistorySaga);

  yield takeEvery(types.GET_SETTING_TRENDING_PRODUCT, getSettingTrendingProductSaga);
  yield takeEvery(types.SAVE_SETTING_TRENDING_PRODUCT, saveSettingTrendingProductSaga);

  yield takeEvery(types.GET_SETTING_TOP_DISCOUNT, getSettingTopDiscountSaga);
  yield takeEvery(types.SAVE_SETTING_TOP_DISCOUNT, saveSettingTopDiscountSaga);
  yield takeEvery(types.GET_LIST_PRODUCTS_DETAIL, getListProductsDetailSaga);

  yield takeEvery(types.GET_SETTING_BEST_SELLING, getSettingBestSellingSaga);
  yield takeEvery(types.SAVE_SETTING_BEST_SELLING, saveSettingBestSellingSaga);
  yield takeEvery(
    types.GET_LIST_PRODUCTS_DETAIL_BEST_SELLING,
    getListProductsDetailBestSellingSaga
  );

  yield takeEvery(types.GET_SETTING_QUICK_VIEW, getSettingQuickViewSaga);
  yield takeEvery(types.SAVE_SETTING_QUICK_VIEW, saveSettingQuickViewSaga);
  yield takeEvery(types.GET_REPORT_APP, getReportAppSaga);
}

export default sagaActions;
